import React from 'react';
import { Box, Typography } from '@mui/material';

const AccountSecuritySection = () => (
  <Box>
    <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 2 }}>
      SECURITY
    </Typography>

    <Typography variant="body2" color="text.secondary">
      Email OTP is required on every sign-in for all CS Admin accounts. A welcome email with the
      password setup link will be sent to the email address above.
    </Typography>
  </Box>
);

export default AccountSecuritySection;
